import React from 'react';
import styled from 'styled-components';
import { AccordionItem } from './AccordionItem';
import { FaqItem } from '../../../../types/globalTypes';
import { device } from '../../../../constants';

interface AccordionProps {
  faqs: FaqItem[];
}

export const Accordion: React.FC<AccordionProps> = ({ faqs }) => {
  return (
    <AccordionWrapper>
      {faqs.map(item => (
        <AccordionItem key={item.id} item={item} />
      ))}
    </AccordionWrapper>
  );
};

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1;
  @media screen and ${device.md} {
    gap: 20px;
  }
`;
